<template>
  <span v-if="itemid">
    <v-btn icon @click="dialog = true" :disabled="$attrs.disabled">
      <v-icon :color="$attrs.color">delete</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" v-if="dialog" max-width="500px" modal>
      <v-card>
        <v-card-text class="pt-4">
          <div v-if="!success && !loading">
            <h2>Are you sure you want to delete this?</h2>
            <div>
              ID: <em>{{ itemid }}</em>
            </div>
            <div>
              URL: <em>{{ url || "not provided" }}</em>
            </div>
          </div>

          <div v-if="success">
            <v-icon size="large" color="success">check</v-icon> Deleted
            <v-spacer />
          </div>

          <div v-if="loading">
            <v-progress-circular v-show="loading" :indeterminate="true" />
            Deleting...
          </div>

          <error-messages v-if="showErrors" :errors="errors">
            The following errors were encountered when trying to delete this
            item:
          </error-messages>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="deleteItem" v-if="!success && !loading"
            >Delete it</v-btn
          >
          <v-btn @click="dialog = false" v-if="!success && !loading"
            >Cancel</v-btn
          >
          <v-btn @click="dialog = false" v-if="success">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: "DeleteItemButton",
  data() {
    return {
      dialog: false,
      loading: false,
      errors: [],
      success: false
    };
  },
  props: {
    itemid: {
      type: Number,
      required: true
    },
    resourceid: {
      type: Number,
      required: false
    },
    url: {
      type: String,
      required: true
    },
    confirm: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    showErrors() {
      return this.errors.length > 0;
    }
  },
  methods: {
    async deleteItem() {
      this.loading = true;
      this.success = false;
      this.errors = [];

      try {
        var result = await this.$http.delete(`/${this.url}/${this.itemid}`);

        if (result) {
          this.success = true;
          setTimeout(() => {
            this.$emit("delete", this.itemid);
          }, 1500);
        }
      } catch (e) {
        this.handleError(e);
      }
      this.loading = false;
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  }
};
</script>

<style></style>
